module.exports = __webpack_public_path__ + "static/media/tm-colorit-2.9568b9fb.webp";